import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ModuleschildAuthService {
  setRestriction: any
  view: any

  constructor() { }

  isAuthenticatedmodule() {
    if(localStorage.getItem('moduleAccessbyUser')) {
      return true
    }
    return false;
  }

  getModule() {
    this.setRestriction  = JSON.parse(localStorage.getItem('moduleAccessbyUser'));
    return this.setRestriction;
  }
}
